import * as xss from 'xss';
// These options are mirrored at https://github.com/reproio/repro.rails/blob/develop/app/assets/javascripts/components/marketing/web_messages/xss_options.js
// Be sure to update both files if any changes are made.

const reproDefaultAllowedAttributes = [
  'id',
  'class',
  'style',
  'data-repro--wrapper',
  'data-repro--close',
  'data-repro--no-close',
  'data-repro--primary-btn',
  'data-repro--secondary-btn',
  'data-repro--third-btn',
  'data-repro--fourth-btn',

  'data-repro--primary-image',
  'data-repro--secondary-image',
  'data-repro--third-image',
  'data-repro--fourth-image',

  'data-silver-egg-cref',
  'data-silver-egg-prod',
];

// IWhiteList の要素数が多いのでインデックスシグネチャを充てて拡張する
const defaultWhitelist = xss.getDefaultWhiteList() as XSS.IWhiteList & { [key: string]: string[] };
const reproWhitelist = Object.keys(defaultWhitelist).reduce(
  (result, tagName) => ({
    ...result,
    [tagName]: defaultWhitelist[tagName].concat(reproDefaultAllowedAttributes),
  }),
  {}
);

export const xssHtmlOptions = {
  whiteList: {
    ...reproWhitelist,
    a: [...reproDefaultAllowedAttributes, 'href', 'target', 'title'],
    button: [
      ...reproDefaultAllowedAttributes,
      'autofocus',
      'disabled',
      'form',
      'formaction',
      'formenctype',
      'formmethod',
      'formnovalidate',
      'formtarget',
      'name',
      'type',
      'value',
    ],
    fieldset: [...reproDefaultAllowedAttributes, 'disabled', 'form', 'name'],
    form: [
      ...reproDefaultAllowedAttributes,
      'accept',
      'accept-charset',
      'action',
      'autocomplete',
      'enctype',
      'method',
      'name',
      'novalidate',
      'target',
    ],
    img: [...reproDefaultAllowedAttributes, 'src', 'alt', 'title', 'width', 'height'],
    input: [
      ...reproDefaultAllowedAttributes,
      'accept',
      'align',
      'alt',
      'autocomplete',
      'autofocus',
      'checked',
      'dirname',
      'disabled',
      'form',
      'formaction',
      'formenctype',
      'formmethod',
      'formnovalidate',
      'formtarget',
      'height',
      'list',
      'max',
      'maxlength',
      'min',
      'multiple',
      'name',
      'pattern',
      'placeholder',
      'readonly',
      'required',
      'size',
      'src',
      'step',
      'type',
      'value',
      'width',
    ],
    label: [...reproDefaultAllowedAttributes, 'for', 'form'],
    legend: reproDefaultAllowedAttributes,
    option: [...reproDefaultAllowedAttributes, 'disabled', 'label', 'selected', 'value'],
    select: [...reproDefaultAllowedAttributes, 'autofocus', 'disabled', 'form', 'multiple', 'name', 'required', 'size'],
    optgroup: [...reproDefaultAllowedAttributes, 'disabled', 'label'],
    source: [...reproDefaultAllowedAttributes, 'src', 'srcset', 'media', 'size', 'type'],
    style: [],
    textarea: [
      ...reproDefaultAllowedAttributes,
      'autofocus',
      'cols',
      'dirname',
      'disabled',
      'form',
      'maxlength',
      'name',
      'placeholder',
      'readonly',
      'required',
      'rows',
      'wrap',
    ],
  },
  onIgnoreTagAttr: (_: string, name: string, value: string): string | void => {
    if (name.startsWith('aria-')) {
      return `${name}="${xss.escapeAttrValue(value)}"`;
    }
  },
  stripIgnoreTagBody: true,
};
